import React from 'react';
import {
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel,
  CheckboxProps,
} from '@mui/material';
import { ArtistCategory } from '../../@types/api';

const WEDDING = 1;
const CEILIDH = 2;
const JAZZ = 3;
const SPECIALIST = 6;
const CLASSICAL = 8;

const checkBoxProps: CheckboxProps = {
  color: 'primary',
  size: 'small',
  sx: { py: 0 },
};

interface Props {
  categories: ArtistCategory[];
  className: string;
  addCategory: (cat: number) => void;
  removeCategory: (cat: number) => void;
}
const CategoryList: React.FC<Props> = ({
  categories,
  className,
  addCategory,
  removeCategory,
}) => {
  const hasCategory = (categoryId: number) => {
    return categories.some((x: ArtistCategory) => x.categoryId === categoryId);
  };

  const toggleCategory = (categoryId: number) => {
    if (hasCategory(categoryId)) {
      removeCategory(categoryId);
    } else {
      addCategory(categoryId);
    }
  };

  return (
    <FormControl component='fieldset' className={className}>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={hasCategory(WEDDING)}
              onChange={() => toggleCategory(WEDDING)}
              name='Wedding'
              {...checkBoxProps}
            />
          }
          label='Wedding / Function Bands'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={hasCategory(CEILIDH)}
              onChange={() => toggleCategory(CEILIDH)}
              name='Ceildh'
              {...checkBoxProps}
            />
          }
          label='Scottish Ceilidh Bands'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={hasCategory(JAZZ)}
              onChange={() => toggleCategory(JAZZ)}
              name='Jazz'
              {...checkBoxProps}
            />
          }
          label='Jazz and Blues'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={hasCategory(SPECIALIST)}
              onChange={() => toggleCategory(SPECIALIST)}
              name='Specialist'
              {...checkBoxProps}
            />
          }
          label='Specialist and Tribute Bands'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={hasCategory(CLASSICAL)}
              onChange={() => toggleCategory(CLASSICAL)}
              name='Classical'
              {...checkBoxProps}
            />
          }
          label='Classical Artists'
        />
      </FormGroup>
    </FormControl>
  );
};

export default CategoryList;
